import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Select } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import Button from "@/components/common/Button";
import { CloseOutlined } from "@/config/antd";
import { useLoader } from "@/hooks/LoaderProvider";
import Success from "@/components/common/alerts/Success";

const EditMemberDialog = ({
  isVisible,
  onClose,
  member,
  onUpdateMember,
  roles,
}) => {
  const [selectedRole, setSelectedRole] = useState(member?.role);
  const [isSuccessVisible, setIsSuccessVisible] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleUpdate = () => {
    onClose();
    showLoader();

    setTimeout(() => {
      hideLoader();
      onUpdateMember(member.id, selectedRole);
      setIsSuccessVisible(true);
    }, 2000);
  };

  return (
    <>
      <Modal
        open={isVisible}
        onCancel={onClose}
        footer={null}
        centered
        width={350}
        closeIcon={null}
        styles={{
          body: { padding: 0 },
          content: {
            padding: 0,
            borderRadius: "16px",
            overflow: "hidden",
          },
          mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
        }}>
        <div className="flex flex-col bg-white">
          <div className="p-4 flex justify-end">
            <CloseOutlined
              onClick={onClose}
              className="cursor-pointer"
              style={{
                color: "var(--veegil-color-primary)",
                backgroundColor: "var(--veegil-color-lighter-blue)",
                borderRadius: "50%",
                padding: "4px",
              }}
            />
          </div>

          <div className="flex flex-col items-center px-6 pb-6">
            <Avatar
              src={member?.profileImage || member?.avatar}
              size={120}
              shape="circle"
              className="mb-4"
            />
            <h2 className="heading-regular text-primary mb-4">
              {member?.name}
            </h2>
            <Select
              value={selectedRole}
              onChange={setSelectedRole}
              options={roles}
              placeholder="Select Role"
              style={{ width: "100%" }}
              size="large"
              className="mb-6"
            />
          </div>

          <div className="w-full bg-lighterBlue p-4 flex gap-3">
            <Button
              text="Cancel"
              color="secondary"
              className="flex-1 border border-primary"
              customBgColor="white"
              customTextColor="primary"
              onClick={onClose}
            />
            <Button
              text="Update"
              color="primary"
              className="flex-1"
              customBgColor="primary"
              customTextColor="white"
              onClick={handleUpdate}
            />
          </div>
        </div>
      </Modal>

      <Success
        isVisible={isSuccessVisible}
        onClose={() => setIsSuccessVisible(false)}
        header="Member Updated"
        paragraph={`${member?.name}'s role has been updated successfully.`}
        buttonText="Close"
        onButtonClick={() => setIsSuccessVisible(false)}
      />
    </>
  );
};

EditMemberDialog.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  member: PropTypes.shape({
    id: PropTypes.number,
    avatar: PropTypes.string,
    profileImage: PropTypes.string,
    name: PropTypes.string,
    role: PropTypes.string,
  }),
  onUpdateMember: PropTypes.func,
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default EditMemberDialog;
